// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hJ976","inputWrapper":"styles_inputWrapper__wMhFF","btnWrapper":"styles_btnWrapper__1ArQa"};